import { useEffect, useState, useCallback, useRef } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export function Captcha({ onChange, testid = "captcha" }) {
  const [c, setC] = useState(null);
  const [answer, setAnswer] = useState("");
  const onChangeRef = useRef(onChange);
  useEffect(() => { onChangeRef.current = onChange; });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/captcha");
      setC(data);
      setAnswer("");
      onChangeRef.current({ token: data.token, answer: "" });
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const change = (v) => {
    setAnswer(v);
    if (c) onChangeRef.current({ token: c.token, answer: v });
  };

  return (
    <div>
      {/* Honeypot: hidden field, real users never fill it */}
      <input type="text" name="website" tabIndex={-1} autoComplete="off" data-testid={`${testid}-honeypot`} onChange={(e) => onChange({ website: e.target.value })} className="absolute left-[-9999px] h-0 w-0 opacity-0" aria-hidden="true" />
      <div className="flex items-end gap-2">
        <div className="flex-1">
          <label className="flex items-center gap-1.5 text-sm font-medium text-slate-700"><ShieldCheck className="h-4 w-4 text-[#1D9BF0]" />Anti-spam : combien font {c?.question || "…"} ?</label>
          <Input data-testid={`${testid}-answer`} value={answer} onChange={(e) => change(e.target.value)} inputMode="numeric" placeholder="Votre réponse" className="mt-1 h-11 rounded-xl" />
        </div>
        <button type="button" data-testid={`${testid}-refresh`} onClick={load} className="mb-0.5 flex h-11 w-11 items-center justify-center rounded-xl border-2 border-slate-200 text-slate-500 hover:text-[#1D9BF0]"><RefreshCw className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
